interface InlineAlertProps {
  tone?: "info" | "warning" | "error" | "success";
  children: React.ReactNode;
}

const toneStyles: Record<NonNullable<InlineAlertProps["tone"]>, string> = {
  info: "bg-sky-50 text-sky-700 border-sky-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export default function InlineAlert({ tone = "info", children }: InlineAlertProps) {
  return <div className={`rounded border px-3 py-2 text-sm ${toneStyles[tone]}`}>{children}</div>;
}
